module.exports = __webpack_public_path__ + "static/media/slider-agency-website-slide-03-image-01.a6c97745.png";